import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';

export default {
  title: validatePresence(true),
  fte: validateNumber({ integer: false }),
  initiative_capacity: validateNumber({ integer: true }),
  distribution_vision: validateNumber({ integer: true }),
  distribution_customer: validateNumber({ integer: true }),
  distribution_operations: validateNumber({ integer: true }),
  limit_lower_vision: validateNumber({ integer: true }),
  limit_upper_vision: validateNumber({ integer: true }),
  limit_lower_customer: validateNumber({ integer: true }),
  limit_upper_customer: validateNumber({ integer: true }),
  limit_lower_operations: validateNumber({ integer: true }),
  limit_upper_operations: validateNumber({ integer: true }),

  // duration: [validateFormat({ type: 'st', allowBlank: true })],
  // theme:
};
